<template>
  <div>
    <div class="page-wrapper coach-content-wrapper">
      <div class="container">
        <div class="content">
          <BaseLoading  :spinning="videosLoading">
            <div class="videos-form-wrap">
              <div class="container search-content heading text-uppercase">
                <h2 class="form-title">
                  VIDEOS (UP TO {{ onlyPremiumClubHeadCoach() ? 18 : 3 }})
                </h2>
              </div>
              <div class="videos-list">
                <div
                  class="video-detail"
                  v-for="(item, index) in localVideos"
                  :key="index"
                >
                  <a-row :gutter="24">
                    <a-col :sm="4" :md="3">
                      <div class="title-info">Video {{ index + 1 }}</div>
                    </a-col>
                    <a-col :sm="5" :md="4">
                      <BaseInput
                        name="videoTitle"
                        :value="item.videoDesc"
                        @change="
                          event => (item['videoDesc'] = event.target.value)
                        "
                      />
                    </a-col>
                    <a-col :sm="15" :md="9">
                      <BaseInput
                        name="videoTitle"
                        :value="item.videoUrl"
                        @change="
                          event => (item['videoUrl'] = event.target.value)
                        "
                      />
                    </a-col>
                    <a-col :sm="24" :md="7">
                      <div class="button-wrap">
                        <span v-if="item._id">
                          <a-popconfirm
                            title="Sure you want to delete this video?"
                            @confirm="handleItemDelete(item._id)"
                            ok-text="Yes"
                            cancel-text="No"
                          >
                            <a-button type="danger" icon="delete">
                              Delete
                            </a-button>
                          </a-popconfirm>
                        </span>
                        <span>
                          <BaseButton
                            @click="
                              item._id
                                ? handleUpdateButton(
                                    item.videoUrl,
                                    item.videoDesc,
                                    item._id
                                  )
                                : handleSaveButton(
                                    item.videoUrl,
                                    item.videoDesc
                                  )
                            "
                            :disabled="
                              disableSave(item.videoUrl, item.videoDesc)
                            "
                            type="primary"
                          >
                            {{ item._id ? "Update" : "Save" }}
                          </BaseButton>
                        </span>
                        <span>
                          <BaseButton
                            @click="handleImagePreview(item.videoUrl)"
                            :disabled="!item.videoUrl"
                            type="primary"
                          >
                            Preview
                          </BaseButton>
                        </span>
                      </div>
                    </a-col>
                  </a-row>
                  <a-modal
                    class="custom-modal video-modal"
                    v-model="visible"
                    :footer="null"
                    title=""
                  >
                    <video-embed
                      :src="videoUrl"
                      sandbox="allow-scripts allow-same-origin allow-presentation"
                    ></video-embed>
                  </a-modal>
                </div>
              </div>
            </div>
          </BaseLoading>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const STORE_KEY = "clubStore";
import { mapGetters } from "vuex";
import { Club } from "@/models";

export default {
  data() {
    return {
      visible: false,
      videoUrl: "",
      localVideos: [],
      videoObject: {
        _id: "",
        videoDesc: "",
        videoUrl: "",
        clubId: localStorage["club-id"]
      }
    };
  },
  computed: {
    ...mapGetters({
      videos: `${STORE_KEY}/videos`,
      videosLoading: `${STORE_KEY}/videosLoading`
    })
  },
  created() {
    this.dispatcher();
  },
  methods: {
    disableSave(video, desc) {
      return video && desc ? false : true;
    },
    async dispatcher() {
      await this.$store.dispatch(`${STORE_KEY}/getVideos`, {
        id: localStorage["club-id"],
        limit: 18,
        page: 1
      });
    },
    handleImagePreview(videoUrl) {
      this.videoUrl = videoUrl;
      this.visible = true;
    },
    async handleSaveButton(videoUrl, videoDesc) {
      await this.$store.dispatch(`${STORE_KEY}/saveClubVideos`, {
        clubId: localStorage["club-id"],
        slug: "clubprofile",
        videoUrl,
        videoDesc
      });
      await this.$store.dispatch(`${STORE_KEY}/getVideos`, {
        id: localStorage["club-id"],
        limit: 18,
        page: 1
      });
    },
    async handleUpdateButton(videoUrl, videoDesc, id) {
      await this.$store.dispatch(`${STORE_KEY}/updateClubVideos`, {
        slug: "clubvideos",
        id,
        videoUrl,
        videoDesc
      });
      await this.$store.dispatch(`${STORE_KEY}/getVideos`, {
        id: localStorage["club-id"],
        limit: 18,
        page: 1
      });
    },
    async handleItemDelete(id) {
      await this.$store.dispatch(`${STORE_KEY}/deleteClubVideos`, {
        slug: "clubvideo",
        id: id
      });
      await this.$store.dispatch(`${STORE_KEY}/removeDeletedVideoMutation`, {
        id: id
      });
    }
  },
  watch: {
    videos(newVal, _) {
      if (this.onlyPremiumClubHeadCoach()) {
        this.localVideos =
          newVal.length === 18
            ? newVal
            : [
                ...newVal,
                new Object({
                  _id: "",
                  videoDesc: "",
                  videoUrl: "",
                  collegeId: localStorage["college-id"]
                })
              ];
      }
      if (this.exceptPremiumClubHeadCoach()) {
        this.localVideos =
          newVal.length === 3
            ? newVal
            : [
                ...newVal,
                new Object({
                  _id: "",
                  videoDesc: "",
                  videoUrl: "",
                  collegeId: localStorage["college-id"]
                })
              ];
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
